import React from 'react';
import { col_image,col_large } from "../../Fonctions.js";
import deontologie from '../../Resources/deontologie.png';

function Deontologie({className}) {
    return (
        <section className={`bandeau ${className}`} id="deontologie">
    <div className="row">
    <div className={`col-xs-12 ${col_image}`}>
        <img className="img-fluid" src={deontologie} alt='Illustration déontologie' />
    </div>
    <div className={`col-xs-12 ${col_large}`}>
        <h1>Déontologie</h1>
        <ul>
            <li>
                <h2>Transparence</h2>
                <ul>
                    <li>
                    <p>Nous fournissons un rapport détaillé des sommes collectées et reversées à la recherche.</p>
                    </li>
                </ul>

            </li>
        </ul>
        <ul>
            <li>
                <h2>Efficience</h2>
                <ul>
                    <li>
                    <p>Les fonds sont directement affectés aux programmes de recherche sur les sarcomes.</p>
                    </li>
                </ul>

            </li>
        </ul>
        <ul>
            <li>
                <h2>Traçabilité</h2>
                <ul>
                    <li>
                    <p>Nous informons sur les avancées et résultats obtenus grâce aux dons.</p>
                    </li>
                </ul>

            </li>
        </ul>
    </div>
</div>
</section>
)}

export default Deontologie;